import React, { useEffect, useState } from 'react';
import { Button, Upload, message } from 'antd';
import {
  UploadOutlined,
  SoundOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props {
  form: UseFormReturn<any>;
  controllerProps: any;
  existingUrl?: string; // pass audio URL if it exists
}

const FormAudioUpload: React.FC<Props> = ({
  form,
  controllerProps,
  existingUrl,
}) => {
  const { t } = useTranslation();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | undefined>(existingUrl);

  useEffect(() => {
    return () => {
      if (previewUrl?.startsWith('blob:')) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  useEffect(() => {
    console.log(existingUrl, 'huy');
    if (!existingUrl || existingUrl === '') {
      setPreviewUrl('');
      setSelectedFile(null);
    }
  }, [existingUrl]);

  return (
    <Controller
      {...controllerProps}
      control={form.control}
      render={({ field }) => (
        <div>
          <Upload
            beforeUpload={(file) => {
              const isLt50M = file.size / 1024 / 1024 < 50;
              if (!isLt50M) {
                message.error(t('formAudioUpload.fileTooLarge'));
                return Upload.LIST_IGNORE;
              }

              setSelectedFile(file);
              const blobUrl = URL.createObjectURL(file);
              setPreviewUrl(blobUrl);

              field.onChange(file); // store File in form state
              return false;
            }}
            maxCount={1}
            accept="audio/*"
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />}>
              {selectedFile || previewUrl
                ? t('formAudioUpload.replaceAudio')
                : t('formAudioUpload.selectAudioFile')}
            </Button>
          </Upload>

          {previewUrl && (
            <div
              style={{
                marginTop: '10px',
                gap: 10,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <SoundOutlined style={{ marginRight: '8px' }} />
              <span style={{ marginRight: '10px' }}>
                {selectedFile
                  ? selectedFile.name
                  : previewUrl.split('/').pop() ||
                    t('formAudioUpload.currentAudio')}
              </span>
              <Button
                type="link"
                icon={<CloseCircleOutlined />}
                danger
                size="small"
                onClick={() => {
                  setSelectedFile(null);
                  setPreviewUrl(undefined);
                  field.onChange(null);
                }}
              >
                {t('common.remove')}
              </Button>
              <audio
                controls
                src={previewUrl}
                style={{ display: 'block', marginTop: '10px', width: '100%' }}
              />
            </div>
          )}
        </div>
      )}
    />
  );
};

export default FormAudioUpload;
